<template>
  <div>
    <Base :flag-icon="requirement.value.toLowerCase()" :satisfied="requirement.satisfied" tooltip>
      <span>
        {{ requirement.negative ? 'Not from' : 'From' }}
        {{ requirement.value }}
      </span>
      <span slot="tooltip">
        {{ first ? 'The ideal candidate' : 'and' }}
        {{ requirement.negative ? 'not' : '' }}
        have nationality in {{ requirement.value }}
      </span>
    </Base>
  </div>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
